import { render, staticRenderFns } from "./PhotoEdit.vue?vue&type=template&id=679fabbc&scoped=true&"
import script from "./PhotoEdit.vue?vue&type=script&lang=js&"
export * from "./PhotoEdit.vue?vue&type=script&lang=js&"
import style0 from "./PhotoEdit.vue?vue&type=style&index=0&id=679fabbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679fabbc",
  null
  
)

export default component.exports